var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"gb-ant-form-item-wrap",attrs:{"id":_vm.labelKey}},[_c('a-form-item',_vm._b({staticClass:"gb-form-item",class:{
      'gb-form-item-text-wrap': _vm.textWrap,
      'gb-form-item-text-100p': _vm.formElem100p
    },attrs:{"label":_vm.label,"colon":_vm.colon}},'a-form-item',_vm.$attrs,false),[_vm._t("default")],2)],1)}
var staticRenderFns = []

export { render, staticRenderFns }